module.exports = __webpack_public_path__ + "img/engenious-white.f0055d0b.svg";